import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

// Istanza MSAL condivisa, in un modulo a parte per evitare import circolari
// tra index.js (che la crea/inizializza) e i moduli non-React (es. interceptor)
// che devono usarla per acquisire i token.
export const msalInstance = new PublicClientApplication(msalConfig);
